import React from "react";
import { MapPin, Image as ImageIcon, ArrowsUpFromLine } from "lucide-react";
import { categoryLabel } from "@/data/portfolioCategories";

export default function ProjectCard({ project, onOpen }) {
  const cover = project.images?.[0];
  const extra = (project.images?.length || 0) - 1;

  return (
    <button
      type="button"
      onClick={() => onOpen(project)}
      className="group text-left bg-white border border-gray-200 rounded-lg overflow-hidden hover:border-br-bronze hover:shadow-xl transition focus:outline-none focus-visible:ring-2 focus-visible:ring-br-bronze focus-visible:ring-offset-2"
      data-testid={`portfolio-card-${project.id}`}
    >
      <div className="relative aspect-[4/3] bg-br-paper overflow-hidden">
        {cover ? (
          <img
            src={cover.data_url}
            alt={cover.alt || project.title}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-400">
            <ImageIcon size={32} />
          </div>
        )}
        <div className="absolute top-3 left-3 bg-br-black/85 text-white text-[10px] uppercase tracking-[0.22em] font-bold px-2.5 py-1 rounded">
          {categoryLabel(project.category)}
        </div>
        {project.is_before_after && (
          <div className="absolute top-3 right-3 bg-br-bronze text-white text-[10px] uppercase tracking-[0.22em] font-bold px-2.5 py-1 rounded flex items-center gap-1">
            <ArrowsUpFromLine size={11} /> Before / After
          </div>
        )}
        {extra > 0 && (
          <div className="absolute bottom-3 right-3 bg-br-black/75 text-white text-[11px] font-semibold px-2 py-1 rounded">
            +{extra} more
          </div>
        )}
      </div>
      <div className="p-5">
        <h3 className="font-display tracking-wider uppercase text-lg text-br-black group-hover:text-br-bronze transition">{project.title}</h3>
        {project.city && (
          <div className="mt-1.5 flex items-center gap-1.5 text-xs text-gray-500">
            <MapPin size={12} className="text-br-bronze" /> {project.city}
          </div>
        )}
        {project.description && (
          <p className="mt-2 text-sm text-gray-700 leading-relaxed line-clamp-3">{project.description}</p>
        )}
      </div>
    </button>
  );
}
